import type { WalletSettlementInput } from './read-model';

export const SLICE06_QA_SETTLEMENTS_KEY = 'ownyou.slice06.qa.settlements';
export const SLICE06_QA_SETTLEMENTS_BACKUP_KEY = 'ownyou.slice06.qa.settlements.backup';

export function isQaToolsEnabled(): boolean {
  return import.meta.env.DEV || import.meta.env.VITE_ENABLE_HITL_QA_TOOLS === 'true';
}

export function walletHitlFixturesEnabled(): boolean {
  return isQaToolsEnabled();
}

export function readSlice06QaSettlementFixtures(): WalletSettlementInput[] {
  if (!walletHitlFixturesEnabled()) return [];
  if (typeof localStorage === 'undefined') return [];

  try {
    const raw = localStorage.getItem(SLICE06_QA_SETTLEMENTS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(isSettlementInput);
  } catch {
    return [];
  }
}

export function writeSlice06QaSettlementFixtures(rows: readonly WalletSettlementInput[]): void {
  if (typeof localStorage === 'undefined') return;
  const existingBackup = localStorage.getItem(SLICE06_QA_SETTLEMENTS_BACKUP_KEY);
  if (existingBackup === null) {
    localStorage.setItem(SLICE06_QA_SETTLEMENTS_BACKUP_KEY, localStorage.getItem(SLICE06_QA_SETTLEMENTS_KEY) ?? '');
  }
  localStorage.setItem(SLICE06_QA_SETTLEMENTS_KEY, JSON.stringify(rows));
}

export function cleanupSlice06QaSettlementFixtures(): void {
  if (typeof localStorage === 'undefined') return;
  const backup = localStorage.getItem(SLICE06_QA_SETTLEMENTS_BACKUP_KEY);
  if (backup === null) {
    localStorage.removeItem(SLICE06_QA_SETTLEMENTS_KEY);
    return;
  }
  if (backup) localStorage.setItem(SLICE06_QA_SETTLEMENTS_KEY, backup);
  else localStorage.removeItem(SLICE06_QA_SETTLEMENTS_KEY);
  localStorage.removeItem(SLICE06_QA_SETTLEMENTS_BACKUP_KEY);
}

function isSettlementInput(value: unknown): value is WalletSettlementInput {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<WalletSettlementInput>;
  return (
    typeof candidate.tx_hash === 'string' &&
    typeof candidate.campaign_ref === 'string' &&
    typeof candidate.rotation_counter === 'number' &&
    typeof candidate.recipient === 'string' &&
    typeof candidate.amount === 'string' &&
    (typeof candidate.observed_at === 'string' || typeof candidate.observed_at === 'number')
  );
}
